import { createStore } from 'vuex'

export default createStore({
  state: {
    lastyearcompanycode : '',
    lastyearcompanyname : '',
  },
  getters: {
  },
  mutations: {
    setlastyearcompanycode(state,val){
      state.lastyearcompanycode = val.lastyearcompanycode
      state.lastyearcompanyname = val.lastyearcompanyname
      console.log('state',state.lastyearcompanycode)
      console.log('state',state.lastyearcompanyname)
    },
  },
  actions: {
  },
  modules: {
  }
})
